export default class NoteTypeService {
    static fromJSON(json) {
        // @ts-expect-error - TS2739 - Type '{ id: number; }' is missing the following properties from type 'NoteType': name, active, isAlertNoteType
        return Object.assign(Object.assign({}, json), { id: parseInt(json.id, 0) });
    }
}
